import { Amplify } from 'aws-amplify'
import { generateClient } from 'aws-amplify/api'

import { resolveAmplifyConfig } from './amplifyConfig'

const configModules = import.meta.glob('../amplifyconfiguration.json', {
  eager: true,
}) as Record<string, { default: Record<string, unknown> }>
const amplifyConfig = resolveAmplifyConfig(configModules)

Amplify.configure(amplifyConfig)

export const AmplifyGraphQLclient = generateClient()
